import React, { Fragment, useContext, useEffect } from "react";
import PropTypes from "prop-types";

import PostContext from "../../context/post/postContext";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  img: {
    display: "block",
    overflow: "hidden",
    width: "100%",
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
}));

const Showcase = (props) => {
  const classes = useStyles();

  const postContext = useContext(PostContext);

  const { posts, getPosts, loading } = postContext;

  useEffect(() => {
    getPosts();
    //eslint-disable-next-line
  }, []);

  const startPhotoNum = props.startPhotoNum;
  const maxPhotoNumInOnePage = props.maxPhotoNumInOnePage;

  // showcase posts are those with cover photo and favoriated,
  // up to 20 ordered from the latest to oldest
  const valid_showcase_posts = posts
    .filter((post) => {
      return (
        post.cover_photo !== undefined &&
        post.cover_photo !== null &&
        post.is_favorite === true
      );
    });

  const showcase_posts =
    valid_showcase_posts.length < startPhotoNum * 2
      ? valid_showcase_posts.slice(0, maxPhotoNumInOnePage)
      : valid_showcase_posts.slice(startPhotoNum, maxPhotoNumInOnePage);

  if (loading) {
    return <CircularProgress />;
  }

  if (showcase_posts !== null && showcase_posts.length === 0 && !loading) {
    return <Fragment></Fragment>;
  }

  return (
    <div className={classes.root}>
      <GridList className={classes.gridList}>
        {showcase_posts.map((post) => (
          <GridListTile key={post.title}>
            <img
              className={classes.img}
              src={post.cover_photo.image_link}
              alt={post.title}
            />
            <GridListTileBar
              title={post.title}
              //   actionIcon={
              //     <IconButton
              //       aria-label={`info about ${post.title}`}
              //       className={classes.icon}
              //     >
              //       <InfoIcon />
              //     </IconButton>
              //   }
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}

Showcase.propTypes = {
  startPhotoNum: PropTypes.number.isRequired,
  maxPhotoNumInOnePage: PropTypes.number.isRequired,
};

export default Showcase;